import React, { Component } from "react";
import { get as _get, isEmpty as _isEmpty, isEqual as _isEqual } from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Helmet from "react-helmet";

import { showAlertMessage } from "../../components/common/controls";
import { withRouter } from "../../components/hoc/withRouter";
import { isValidEmail } from "../../helpers/utils.js";

import { createContactUs, clearCreateContactUsResponse } from "../../actions/oauth";

class ContactUs extends Component {
  constructor(props) {
    super(props);

    this.contactNo = "(+44) 7985 447 915";
    this.contactEmail = "david@enrichb2bdata.com";
    this.contactAddress = "130 High Street, Lewes, BN71XL";

    this.state = {
      name: "",
      email: "",
      message: "",
      errors: {},
      isSubmitClicked: false,
      showSuccessSection: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {

    if (
      (!_isEqual(prevState.name, this.state.name) ||
        !_isEqual(prevState.email, this.state.email) ||
        !_isEqual(prevState.message, this.state.message)) &&
      (_get(this.state, "isSubmitClicked", false) === true)
    ) {
      this._handleValidation();
    }

    if (!_isEqual(prevProps.success, this.props.success) && !_isEmpty(this.props.success)) {
      const { clearCreateContactUsResponse, success } = this.props;

      showAlertMessage(_get(success, "message", "Your request has been submitted successfully."), "success");

      if (typeof clearCreateContactUsResponse === "function") { clearCreateContactUsResponse(); }
      this.setState({ name: "", email: "", message: "", showSuccessSection: true });
    }

    if (!_isEqual(prevProps.error, this.props.error) && !_isEmpty(this.props.error)) {
      const { clearCreateContactUsResponse, error } = this.props;

      showAlertMessage(_get(error, "message", "Something went wrong while submitting contact us request."));

      if (typeof clearCreateContactUsResponse === "function") { clearCreateContactUsResponse(); }
    }
  }

  _submitContactUsRequest = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { createContactUs } = this.props;
    const { name, email, message, errors } = this.state;

    if (_isEmpty(name) || !isValidEmail(email) || _isEmpty(message) || !_isEmpty(errors)) {

      this.setState({ isSubmitClicked: true }, () => {
        this._handleValidation();
      });
      return;
    }

    try {

      if (typeof createContactUs === "function") {
        createContactUs({ name: (name || ""), email: (email || ""), message: (message || "") });
      }

    } catch (error) {

      showAlertMessage(_get(error, "message", "Something went wrong while submitting contact us request."));
    }
  }

  _handleValidation = () => {
    const { intl } = this.props;
    const { name, email, message } = this.state;

    let errors = {};

    if (_isEmpty(name)) {
      errors["name"] = intl.formatMessage({ id: "error.required", defaultMessage: "{field} is required." }, {
        field: intl.formatMessage({ id: "name", defaultMessage: "name", }),
      });
    }

    if (!isValidEmail(email)) {
      errors["email"] = intl.formatMessage({ id: "error.invalid", defaultMessage: "Invalid {field}" }, {
        field: intl.formatMessage({ id: "email", defaultMessage: "email", }),
      });
    }

    if (_isEmpty(message)) {
      errors["message"] = intl.formatMessage({ id: "error.required", defaultMessage: "{field} is required." }, {
        field: intl.formatMessage({ id: "message", defaultMessage: "message", }),
      });
    }

    this.setState({ errors });
  }

  _renderContactForm = () => {
    const { name, email, message, errors } = this.state;

    return (
      <div className="row">
        <div className="col-lg-9 mx-auto">
          <form autoComplete="off">
            <div className="row gx-lg-15  px-lg-7">
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="fw-semibold mb-2"><FormattedMessage id="contact.form.label.name" defaultMessage="Name:" /></label>
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Name"
                    value={(name || "")}
                    onChange={(e) => this.setState({ name: _get(e, "target.value", "") })}
                  />
                  {(errors.name || "") && (
                    <p className="small fw-bold text-danger mt-1 ps-26 text-capitalize-first"> {(errors.name || "")}</p>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="fw-semibold mb-2"><FormattedMessage id="contact.form.label.email" defaultMessage="Email:" /></label>
                  <input
                    type="email"
                    className="form-control form-control-lg"
                    placeholder="Email"
                    value={(email || "")}
                    onChange={(e) => this.setState({ email: _get(e, "target.value", "") })}
                  />
                  {(errors.email || "") && (
                    <p className="small fw-bold text-danger mt-1 ps-26 text-capitalize-first"> {(errors.email || "")}</p>
                  )}
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="fw-semibold mb-2"><FormattedMessage id="contact.form.label.message" defaultMessage="Message:" /></label>
                  <textarea
                    className="form-control"
                    placeholder="Message"
                    rows="4"
                    value={(message || "")}
                    onChange={(e) => { this.setState({ message: _get(e, "target.value", "") }) }}
                  />
                  {(errors.message || "") && (
                    <p className="small fw-bold text-danger mt-1 ps-26 text-capitalize-first"> {(errors.message || "")}</p>
                  )}
                </div>
              </div>
              <div className="col-lg-6 mx-auto">
                <div className="mb-2 mt-8">
                  <button className="btn btn-lg btn-primary w-100 text-capitalize" onClick={(e) => this._submitContactUsRequest(e)}>
                    <FormattedMessage id="btn.send" defaultMessage="send" />
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }

  _renderSuccessSction = () => {

    return (
      <div className="section-forgot outer-pattern">
        <div className="container container-1120">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="heading-01 fw-medium text-center mb-lg-9 mb-4">
                <FormattedMessage id="contact.title" defaultMessage="Contact Us" />
              </h1>

              <p className="heading-06 text-grey-63 text-center mb-lg-15 mb-8">
                <FormattedMessage id="contact.success_message" defaultMessage="Your message has been sent and we'll be in contact shortly" />
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 mx-auto">
              <div className="mb-2">
                <Link to="/" className="btn btn-lg btn-primary w-100 text-capitalize">
                  <FormattedMessage id="btn.home" defaultMessage="Home" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { intl } = this.props;
    const { showSuccessSection } = this.state;

    return (
      <>
        <Helmet>
          <title>
            {intl.formatMessage({ id: "enrich.contact", defaultMessage: "Contact: Enrich B2B" })}
          </title>
        </Helmet>
        {((showSuccessSection || false) === false) && (
          <div className="section-login outer-pattern">
            <div className="container container-1120">
              <div className="row">
                <div className="col-lg-12">
                  <h1 className="heading-01 fw-medium text-center mb-lg-9 mb-4">
                    <FormattedMessage id="contact.title" defaultMessage="Contact Us" />
                  </h1>
                  <p className="heading-06 text-grey-63 text-center mb-lg-15 mb-8">
                    <FormattedMessage id="contact.sub_title" defaultMessage="Contact us to enquire or ask any questions – we are here to help at all times." />
                  </p>
                </div>
              </div>

              {(this._renderContactForm())}
            </div>
          </div>
        )}

        {((showSuccessSection || false) === true) && (this._renderSuccessSction())}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  success: _get(state, "oauth.success", {}),
  error: _get(state, "oauth.error", {}),
});

const mapDispatchToProps = (dispatch) => ({
  createContactUs: (data) => dispatch(createContactUs(data)),
  clearCreateContactUsResponse: () => dispatch(clearCreateContactUsResponse()),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ContactUs)));
